import React, { useState, useEffect, useRef, Fragment } from 'react';
import Header from '../commons/Header';
import Footer from '../commons/Footer';
import { useHistory, NavLink, Link } from "react-router-dom";
import { PROJECTNAMEALIAS, NFTAPIBASENAME, COLLECTIONIMAGEBASEURL, NFTIMAGEBASEURL } from '../helpers/Setup'
import { showToast, callAPI, showHttpError, checkIfUserIsLoggedIn, getAllSessionData, removeFromFavorite } from '../helpers/Library';
import Loader from '../commons/Loader';


const FavoritesNftsByUser = (props) => {
    const history = useHistory();
    const [showLoader, setShowLoader] = useState(false);
    const [showStatusCategory, setStatusCategory] = useState(false);
    const [showCurrencyCategory, setCurrencyCategory] = useState(false);
    const [pageNo, setPageNo] = useState(1);
    const [pageSize, setPageSize] = useState(20);
    const [nftCollections, setNftCollections] = useState([]);
    const [nfts, setNfts] = useState([]);
    const [collectionCategories, setCollectionCategories] = useState([]);
    const [selectedCategory, setSelectedCategory] = useState('');

    const [showCreateColBtn, setShowCreateColBtn] = useState(false);




    /* method defination for get colletion list by users */
    let getFavoritesNftsByUsers = () => {
        let payload =
            { "userUuid": getAllSessionData().uuid, "pageNo": pageNo, "pageSize": pageSize }
        setShowLoader(true)
        console.log(payload)
        callAPI('post', NFTAPIBASENAME + '/nft/market/getAllFavouriteNft', payload, true).then((res) => {
            let response = res.data;
            setShowLoader(false);
            console.log(response);
            if (response.error.error_data != 0) {
                showToast('error', response.error.error_msg)
            } else {
                if (response.nfts != undefined && response.nfts != null) {
                    setNfts(response.nfts)
                } else {
                    setNfts([])
                }
                getAllCollectionCategory();
            }

        }, (error) => {
            setShowLoader(false);
            showHttpError(error)
        })

    }

    /* Method defination for get all collection */
    let getAllCollectionCategory = () => {
        let payload = {}
        setShowLoader(true);
        callAPI('get', NFTAPIBASENAME + '/nft/market/public/getAllCollectionCategory', false).then((res) => {
            let response = res.data;
            setShowLoader(false);
            console.log(response);
            if (response.error.error_data != 0) {
                showToast('error', response.error.error_msg)
            } else {
                setCollectionCategories(response.collectionCategories)
            }

        }, (error) => {
            setShowLoader(false);
            showHttpError(error)
        })
    }






    // Similar to componentDidMount and componentDidUpdate:
    useEffect(() => {
        if (!checkIfUserIsLoggedIn()) {
            showToast('error', 'Please login to continue',);
            setTimeout(() => {
                props.history.push("/");
            }, 1000);
        } else {
            getFavoritesNftsByUsers();
        }

    }, []);

    return (
        <Fragment>
            <Header />
            <div className="shop-box-inner">
                <div className="container">
                    <div className="row">
                        <div className="col-xl-12 col-lg-12 col-sm-12 col-xs-12">
                            <h3>Favorites Nfts</h3>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-xl-12 col-lg-12 col-sm-12 col-xs-12 shop-content-right">
                            <div className="right-product-box">
                                {/* <div className="product-item-filter row"> */}
                                {/* <div className="col-12 col-sm-8 text-center text-sm-left">
                                        <div className="toolbar-sorter-right"> */}
                                {/*  <span>Sort by </span> */}
                                {/* <select id="basic" className="form-control" data-placeholder="$ USD" style={{ display: 'block' }}>
                                                <option data-display="Select">Sort By</option>
                                                <option value="1">Popularity</option>
                                                <option value="2">High Price → High Price</option>
                                                <option value="3">Low Price → High Price</option>
                                                <option value="4">Best Selling</option>
                                            </select>
                                        </div> */}
                                {/*  <p>Showing all 4 results</p> */}
                                {/* </div> */}
                                {/* <div className="col-12 col-sm-4 text-center text-sm-right"> */}
                                {/*  <ul className="nav nav-tabs ml-auto">
                                    <li>
                                        <a className="nav-link active" href="#grid-view" data-toggle="tab"> <i className="fa fa-th"></i> </a>
                                    </li>
                                    <li>
                                        <a className="nav-link" href="#list-vifew" data-toggle="tab"> <i className="fa fa-list-ul"></i> </a>
                                    </li>
                                </ul> */}
                                {/* {
                                    showCreateColBtn && 
                                    <Link to="/create-collection" className="btn btn-primary">Create Collection</Link>
                                }
                                    </div> */}
                                {/* </div> */}

                                <div className="product-categorie-box">
                                    <div className="tab-content">
                                        <div role="tabpanel" className="tab-pane fade show active" id="grid-view">
                                            <div className="row">
                                                {nfts.map((nft) => (
                                                    <div className="col-sm-6 col-md-6 col-lg-4 col-xl-4" key={nft.nftId}>
                                                        <Link to={`/asset/` + nft.nftId} data-toggle="tooltip" data-placement="right" title="View">
                                                            <div className="products-single fix">
                                                                <div className="box-img-hover">
                                                                    <img src={NFTIMAGEBASEURL + '/' + nft.nftFileName} className="img-fluid" alt="Image" style={{ width: '100%', height: '100%' }} />
                                                                </div>
                                                                <div className="why-text">
                                                                    <h4>{nft.nftName}</h4>
                                                                    {/* <p>Price : {nft.nftPrice} ETH</p> */}
                                                                    <button className="btn hvr-hover mr-2 " onClick={()=>{removeFromFavorite(nft.nftId,()=>{
                                                                        getFavoritesNftsByUsers();
                                                                    })}}>Remove From Favorites</button>

                                                                </div>
                                                            </div>
                                                        </Link>
                                                    </div>
                                                ))}


                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* <div className="col-xl-3 col-lg-3 col-sm-12 col-xs-12 sidebar-shop-left">
                            <div className="product-categori">
                                <div className="search-product">
                                    <form action="#">
                                        <input className="form-control" placeholder="Search here..." type="text" />
                                        <button type="submit"> <i className="fa fa-search"></i> </button>
                                    </form>
                                </div>
                                <div className="filter-sidebar-left">
                                    <div className="title-left">
                                        <h3>Categories</h3>
                                    </div>
                                    <div className="list-group list-group-collapse list-group-sm list-group-tree" id="list-group-men" data-children=".sub-men">
                                        {collectionCategories.map((cat) => (

                                            <div className="list-group-collapse sub-men" key={cat.nftCollectionCategoryId}>
                                                <a onClick={() => { getColletionListByCategory(cat.nftCollectionCategoryId) }} className={`list-group-item list-group-item-action ${cat.nftCollectionCategoryId == selectedCategory ? 'active' : ''}`} href="javascript:void(0)" >{cat.categoryName}
                                                </a>

                                            </div>
                                        ))}
                                       


                                    </div>
                                </div>
                               
                            </div>
                        </div> */}
                    </div>
                </div>
            </div>











            <Footer />
            <Loader show={showLoader} />
        </Fragment>
    );
}

export default FavoritesNftsByUser;